import { RootState } from "../../store";

export const selectPushNotifications = (state: RootState) => state.pushNotification;

  